import React, { useContext, useState } from "react";

import camelCaseKeys from "camelcase-keys";
import classnames from "classnames";

import { getJsonRequest } from "Helpers/ApiRequest";

import { BrandContext } from "./BrandContext";
import { VenueContext } from "./VenueContext";
import Menu from "./Menu";
import Footer from "./Footer";
import VenueHeader from "./VenueHeader";
import Loading, { useLoadingState } from "./Loading";
import Promotions from "./Promotions";

const bySortOrder = (a, b) => a.sortOrder - b.sortOrder;

const camelCaseItemModGroups = ({ item_mods, ...itemModGroup }) => ({
  ...camelCaseKeys(itemModGroup),
  itemMods: item_mods.map(camelCaseKeys).sort(bySortOrder),
});
const camelCaseItems = ({ item_mod_groups, ...item }) => ({
  ...camelCaseKeys(item),
  salesPrice: parseFloat(item.sales_price),
  itemModGroups: item_mod_groups.map(camelCaseItemModGroups).sort(bySortOrder),
});
const camelCaseSection = ({ items, ...section }) => ({
  ...camelCaseKeys(section),
  items: items.map(camelCaseItems).sort(bySortOrder),
});
const camelCaseMenu = ({ pages, sections, ...menu }) => ({
  ...camelCaseKeys(menu),
  sections: sections.map(camelCaseSection).sort(bySortOrder),
});
const camelCasePromotionalItems = (promotionalItems) => ({
  ...camelCaseKeys(promotionalItems).map((i) => ({
    ...i,
    salesPrice: parseFloat(i.salesPrice),
  })),
});

// This is both used here exported and used on the management site
export const Onsite = ({
  venue,
  menu,
  promotionalItems,
  scrollMarginTop,
  scrollContainterId,
  EmptyMenu,
  MenuComponents,
  VenueComponents,
  previewMenu,
}) => {
  const venueBrand = useContext(BrandContext);
  const showPromotions = Object.keys(promotionalItems).length > 0;

  return (
    <div
      className={classnames(venueBrand.font)}
      style={venueBrand.cssVariables}
    >
      <div className="space-y-24 mb-24">
        <VenueHeader
          VenueComponents={VenueComponents}
          venue={venue}
          menuUpdatedAt={new Date(menu.updatedAt).toDateString()}
        />

        {showPromotions && (
          <div className="px-12 md:px-32">
            <Promotions items={promotionalItems} previewMenu={previewMenu} />
          </div>
        )}
      </div>

      <div
        className={classnames("pb-64 px-12", {
          "bg-venue-foreground": venueBrand.isPlayful,
        })}
      >
        <Menu
          scrollContainterId={scrollContainterId}
          scrollMarginTop={scrollMarginTop}
          MenuComponents={MenuComponents}
          EmptyMenu={EmptyMenu}
          menu={menu}
          previewMenu={previewMenu}
        />
      </div>
      <Footer venue={venue} />
    </div>
  );
};

const Venue = () => {
  const venue = useContext(VenueContext);
  const [menu, setMenu] = useState({});
  const [promotionalItems, setPromotionalItems] = useState({});

  const loadingState = useLoadingState(async () => {
    const { body: menuResponse } = await getJsonRequest({
      url: `/marketing_api/menus/${window.menuUUID}`,
    });
    const { body: promotionResponse } = await getJsonRequest({
      url: `/marketing_api/venues/${window.venueUUID}/marketing_activations`,
    });

    setPromotionalItems(camelCasePromotionalItems(promotionResponse));
    setMenu(camelCaseMenu(menuResponse));
  }, []);
  return (
    <Loading loadingState={loadingState}>
      <Onsite
        scrollContainterId="OnsiteSiteScrollContainer"
        menu={menu}
        MenuComponents={{}}
        venue={venue}
        promotionalItems={promotionalItems}
      />
    </Loading>
  );
};

export default Venue;
